import settings from '../../../config/settings';

export default {
  'app.global.route.auth.login': 'Đăng nhập',
  'app.global.form.validatefields.catch':
    'Kiểm tra lại đầu vào, vui lòng kiểm tra lại',
  'app.global.request.catch': 'Yêu cầu thất bại',
  'app.global.request.catch.description': 'Yêu cầu thất bại {status}: { text }',
  'app.global.no.response.description':
    'Đã xảy ra lỗi trong quá trình kết nối, không thể kết nối đến máy chủ',
  'app.global.no.response.message': 'Kết nối thất bại !',
  'app.global.login.expired':
    'Phiên đăng nhập hiện tại đã hết hạn. Vui lòng đăng nhập lại để tiếp tục.',
  'app.global.error': 'Lỗi',
  'app.global.something.wrong': 'Đã xảy ra lỗi',
  'app.global.custom.error.message': 'Đã xảy ra lỗi không xác định',
  'app.global.not.found': 'Không tìm thấy',
  'app.global.yes': 'Có',
  'app.global.no': 'Không',
  'app.global.not.access': 'Không có quyền truy cập',
  'app.global.success': 'Thành công',
  'app.global.success.delete': 'Xóa thành công!',
  'app.global.success.create': 'Tạo thành công!',
  'app.global.success.update': 'Cập nhật thành công!',
  'app.global.attachFile': 'Đính kèm file',
  'app.global.siteName': settings.siteName,
  'app.global.confirm': 'Xác nhận',
  'app.global.cancel.change':
    'Tất cả thay đổi đã không được lưu. Bạn có muốn hủy bỏ không?',
  'app.global.custom.error.permission.access.page': `Bạn không có quyền truy cập trang này!`,

  // Table field translations
  'app.global.add.row': 'Thêm dòng',
  'app.global.add.column': 'Thêm cột',
  'app.global.column': 'Cột',
  'app.global.title': 'Tiêu đề',
  'app.global.type': 'Loại',
  'app.global.options': 'Tùy chọn',
  'app.global.options.placeholder': 'Nhập tùy chọn và nhấn Enter',
  'app.global.table.columns': 'Cột bảng',
  'app.global.action': 'Hành động',
  'app.global.required': 'Bắt buộc',
  'app.global.field.required': 'Trường này là bắt buộc',

  'app.global.error.delete': 'Xóa thất bại!',
  'app.global.error.update': 'Cập nhật thất bại!',
  'app.global.error.create': 'Tạo thất bại!',

  'input.placeholder.type': 'Nhập vào đây...',
  'input.enter': 'Nhập',
  'input.select': 'Chọn',
  'input.placeholder.choose.one': 'Chọn một',
  'input.placeholder.date': 'Chọn ngày',
  'input.required': '{fieldName} là bắt buộc',
  'input.label.checkAll': 'Chọn tất cả',

  'table.title.actions': 'Hành động',

  'app.global.custom.field': 'Trường',
  'app.global.custom.label': 'Nhãn',
  'app.global.custom.type': 'Loại',
  'app.global.custom.key': 'Key (tự động điền)',
  'app.global.custom.required': 'Bắt buộc',
  'app.global.custom.options': 'Tùy chọn',
  'app.global.custom.options.placeholder': 'Nhập tùy chọn cho trường',
  'app.global.custom.switch.on': 'Bật',
  'app.global.custom.switch.off': 'Tắt',
  'app.global.column.move.up': 'Di chuyển lên',
  'app.global.column.move.down': 'Di chuyển xuống',
  'app.global.column.remove': 'Xóa cột',
  'app.global.custom.dataSource.config': 'Cấu hình nguồn dữ liệu',
  'app.global.custom.dataSource.type': 'Loại nguồn dữ liệu',
  'app.global.custom.dataSource.static': 'Tùy chọn tĩnh',
  'app.global.custom.dataSource.model': 'Mô hình định nghĩa trước',
  'app.global.custom.dataSource.api': 'API',
  'app.global.custom.dataSource.model.select': 'Chọn mô hình',
  'app.global.custom.dataSource.model.placeholder': 'Chọn một mô hình',
  'app.global.custom.dataSource.api.url': 'API URL',
  'app.global.custom.dataSource.api.url.placeholder': 'Nhập API URL',
  'app.global.custom.dataSource.api.responsePath': 'Đường dẫn dữ liệu phản hồi',
  'app.global.custom.dataSource.api.responsePath.placeholder':
    'Ví dụ: data.items',
  'app.global.custom.dataSource.api.responsePath.help':
    'Đường dẫn đến mảng các mục trong phản hồi API (ví dụ: data, data.items, results)',
  'app.global.custom.dataSource.mapping': 'Bản đồ trường',
  'app.global.custom.dataSource.labelField': 'Trường nhãn',
  'app.global.custom.dataSource.labelField.placeholder': 'Ví dụ: name, title',
  'app.global.custom.dataSource.valueField': 'Trường giá trị',
  'app.global.custom.dataSource.valueField.placeholder': 'Ví dụ: id, code',
  'app.global.custom.dataSource': 'Nguồn dữ liệu',
  'app.global.custom.dataSource.cache': 'Bộ nhớ đệm',
  'app.global.custom.dataSource.cache.enabled': 'Bật bộ nhớ đệm',
  'app.global.custom.dataSource.cache.expiration':
    'Thời gian hết hạn bộ nhớ đệm (phút)',
  'app.global.custom.dataSource.predefined': 'Nguồn dữ liệu định nghĩa trước',
  'app.global.custom.dataSource.dynamic': 'Nguồn dữ liệu động',
  'app.global.custom.dataSource.loading': 'Đang tải nguồn dữ liệu...',
  'app.global.custom.dataSource.error': 'Lỗi khi tải nguồn dữ liệu',
  'app.global.custom.dataSource.empty': 'Không có dữ liệu',
  'app.global.custom.dataSource.select': 'Chọn nguồn dữ liệu',
  'app.global.custom.dataSource.refresh': 'Làm mới nguồn dữ liệu',
  'app.global.custom.dataSource.clear.cache': 'Xóa bộ nhớ đệm',

  'status.active': 'Hoạt động',
  'status.inactive': 'Không hoạt động',
  'app.global.all': 'Tất cả',
};
